import { createFileRoute, Navigate } from '@tanstack/react-router';
import { Route as portalRoute } from './_authed/portal';
export const Route = createFileRoute('/')({
  // preload: true,
  //
  // beforeLoad: async () => {
  //   // Instead of calling router.navigate, return a server-side redirect
  //   return redirect({ to: portalRoute.to, replace: true }); // This sends a 302 redirect response on the server
  // },
  // loader: async () => {
  //   // Instead of calling router.navigate, return a server-side redirect
  //   return redirect({ to: portalRoute.to, replace: true }); // This sends a 302 redirect response on the server
  // },

  component: () => {
    return <Navigate to={portalRoute.to} replace />;
  },
});
